import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, RefreshCw, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

const msg = (e, fb) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fb);
const fmt = (n) => (n === null || n === undefined ? "—" : `${Number(n).toFixed(2)} $`);

/** Devis du module Facturation généré depuis le simulateur (créé puis mis à jour tant qu'il n'est pas envoyé) ; l'entente pointe dessus (annexe A). */
export function SimulateurDevis({ edited, onSaveFirst }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => { try { const r = await api.get("/amikobi/rencontre/devis-depuis-simulateur"); setD(r.data); } catch { /* silencieux */ } }, []);
  useEffect(() => { load(); }, [load]);
  const appliquer = async () => {
    setBusy(true);
    try {
      if (edited) await onSaveFirst();
      const r = await api.post("/amikobi/rencontre/devis-depuis-simulateur");
      toast.success(`Devis ${r.data.devis.number} généré — ${fmt(r.data.devis.total)} avant taxes · tarif Amikobi mis à jour · l'entente (annexe A) pointe dessus`);
      await load();
    } catch (e) { toast.error(msg(e, "Devis impossible")); } finally { setBusy(false); }
  };
  const pdf = async () => { try { const r = await api.get(d.pdf, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); } catch { toast.error("PDF impossible"); } };
  return (
    <div className="rounded-lg border border-zinc-800 bg-black/30 p-2 flex flex-wrap items-center gap-2 text-xs" data-testid="amikobi-sim-devis">
      <FileText size={13} className="text-amber-300" />
      {d?.devis ? (
        <span data-testid="amikobi-sim-devis-info">Devis lié : <b>{d.devis.number}</b> · {fmt(d.devis.total)} avant taxes · {d.devis.date}{d.desynchronise && <span className="ml-2 text-amber-300" data-testid="amikobi-sim-devis-desync">⚠ le simulateur a changé depuis — applique de nouveau</span>}</span>
      ) : <span className="text-zinc-400">Aucun devis généré depuis ce simulateur pour l'instant.</span>}
      <span className="ml-auto flex gap-1">
        {d?.devis && <button onClick={pdf} className="px-2 py-1 rounded border border-zinc-700" data-testid="amikobi-sim-devis-pdf">PDF du devis</button>}
        <button onClick={appliquer} disabled={busy} className="inline-flex items-center gap-1 px-2 py-1 rounded bg-amber-500 text-black font-semibold disabled:opacity-50" data-testid="amikobi-sim-devis-appliquer">{busy ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} {d?.devis ? "Appliquer au devis" : "Créer le devis depuis le simulateur"}</button>
      </span>
      {d?.devis?.recommandations?.length > 0 && <ul className="w-full space-y-1 mt-1" data-testid="amikobi-sim-devis-recos">{d.devis.recommandations.map((r, i) => <li key={i} className="rounded border border-amber-500/30 bg-amber-500/5 px-2 py-1 text-[11px] text-amber-100/90">💡 {r}</li>)}</ul>}
    </div>
  );
}
